import { produce } from 'immer';
import { normalize, schema } from 'normalizr';

import { RESET_STATE } from 'store/global/actions';

import { AUTO_LOCK_RULES_ACTION_TYPE } from '../actions';

const autoLockRulesSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

const initialState = {
  isRecalculationAvailable: false,
  rules: {},
};

const autoLockRulesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case AUTO_LOCK_RULES_ACTION_TYPE.GET_AUTO_LOCK_RULES:
        return {
          isRecalculationAvailable: payload.isRecalculationAvailable,
          rules: payload.rules?.length
            ? normalize(payload.rules, [autoLockRulesSchema]).entities.data
            : {},
        };

      case AUTO_LOCK_RULES_ACTION_TYPE.CREATE_AUTO_LOCK_RULE:
      case AUTO_LOCK_RULES_ACTION_TYPE.EDIT_AUTO_LOCK_RULE:
        draft.rules[payload.id] = payload;
        break;

      case AUTO_LOCK_RULES_ACTION_TYPE.REORDER_AUTO_LOCK_RULES:
        payload.forEach(({ ruleId, orderNumber }) => {
          if (draft.rules[ruleId]) {
            draft.rules[ruleId].orderNumber = orderNumber;
          }
        });
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default autoLockRulesReducer;
